// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var DebitCardMapStatus;
(function (DebitCardMapStatus) {
    DebitCardMapStatus[DebitCardMapStatus["PENDING"] = 1] = "PENDING";
    DebitCardMapStatus[DebitCardMapStatus["ACTIVE"] = 2] = "ACTIVE";
    DebitCardMapStatus[DebitCardMapStatus["INACTIVE"] = 3] = "INACTIVE";
})(DebitCardMapStatus || (DebitCardMapStatus = {}));
//# sourceMappingURL=debitCardMapStatus.js.map